<template>
  <div>
    <p class="myanmar">
      ဆန်ဒပြတယ် စိတ်ဆန်ဒထုတ်ဖော်တယ်ဆိုတာ လူထုရဲ့အသံ ၊ လူထုရဲ့ ခံစားချက် နဲ့
      ရပ်တည်ချက်တွေကို ကြွေးကြော်သံများဖြင့် အများသိအောင် ကြေငြာခြင်း ၊
      အချက်အလက်များမျှဝေခံစားခြင်းဟု ခေါ်ဆိုနိုင်ပါသည်။
    </p>
    <p class="myanmar">
      ယခုအခါ မြန်မာနိုင်ငံတွင် မနက်ခင်းမိုးသောက်အချိန်နှိုက်
      ပြည်သူကတင်မြှောက်ထားသော ပြည်သူ့အစိုးရမှခေါင်းဆောင်ပိုင်းမျာအား
      စစ်တပ်မှဖမ်းဆီးထိန်းချုပ်ကာ အာဏာသိမ်းမှုတစ်ရပ်ပြုလုပ်ခဲ့ပါသည်။
      ထိုအချင်းအရာကြောင့် ပြည်သူများကြား ဆန်ဒထုတ်ဖော်မှုများရှိခဲ့ပေမယ့် Covid
      ရောဂါ၏အခြေအနေကြောင့် လမ်းမပေါ်ထွက် ဆန်ဒပြမှုများ တော့မပြုလုပ်ခဲ့ကျပါ။
      သို့ပေမယ် မြန်မာ့ဓလေ့ထုံးစံ မြန်မာ့ဟန်ပန် မြန်မာ့ယဥ်ကျေးမှုကို အခြေပြု၍
      သံပုံများ ၊ စတီးအဖုံးများ ၊ ဒယ်အိုး ဒယ်ခွက်များကို ဇွန်း ၊ ခက်ရင်း ၊
      ယောက်မများ စသောမီးဖိုချောင်သုံး ပစ္စည်းများကိုအသုံးပြုကာတီးခတ်၍
      အာဏာသိမ်းမှုကို လက်မခံဘူးဟူသော လှုပ်ရှားမှု အချို့ပေါ်ပေါက်ခဲ့ပါတယ်။
    </p>
    <p class="myanmar">
      ထို့သို့ပေါ်ပေါက်ပြီး မကြာခင် ရက်အနည်းငယ်အတွင်းမှာပဲ
      ရန်ကုန်မြို့မှလူငယ်တစ်ခု ဦးဆောင်၍ ည ၈နာရီအချိန်ရောက်တိုင်း
      ဖယောင်းတိုင်များထွန်းခြင်း ၊ သံပုံများတီးခတ်ခြင်းကို ပုံသေပြုလုပ်သည့်
      လုပ်ရှားမှူတစ်ရပ်ပေါ်ပေါက်ခဲ့ပါသည်။ ထိုလှုပ်ရှားမှုသည် စတင်သည့်နေတွင်ပင်
      တစ်မြို့လုံး ၊ တစ်နိုင်ငံလုံး ပျံ့နှန့်ကာ ည ၈ နာရီအချိန်ရောက်တိုင်း
      သံပုံးတီးသံများ တဒုန်း တဒုန်း တဝုန်း တဝုန်းဖြင့်
      ကျယ်လောင်စွာပေါ်ထွက်လာခဲ့သည်။ ထိုအသံများ၏စုရပ်ကို အကြမ်းမဖက်ရေး
      လူထုအခြေပြု သံပုံးတီးခတ်ရေးလှုပ်ရှားမှုဟုခေါ်တွင်စေခဲ့သည်။
    </p>
    <p class="myanmar">
      သံပုံးတီခတ်ခြင်းလှုပ်ရှားမှုမှာ မြန့်မာ့ရှေးဘုရင်များ
      လက်ထက်ကတည်းကရှိခဲ့ပြီး ထိုခတ်အခါက ရွာထဲသို့ သူပုန်များ မဝင်ခင်
      သော်လည်းကောင်း ဝင်ပြီးချိန်တွင်လည်းကောင်း အခြားရွာများ ကြားသိအောင်
      သံပုံများ ၊ သံချောင်းများကို တီးခက်သတိပေးခဲ့ကျသည်။ ထို့အပြင် နာနာဘာဝ သရဲ
      တစေ သဘက် များကို မောင်းထုတ်တဲ့အခါလည်း သံပုံးများကို
      တီးခက်၍မောင်းထုတ်ကျရသည်။ တောထဲတောင်ထဲ တွင် တောကောင်ကြီးများ
      ဝင်ရောက်တဲ့အခါတွင်လည်း သံပုံများတီးခက်၍ တောခြောက်သံများပြုလုပ်ကာ
      မောင်းထုတ်ကျရသည်။ ထို အပြုမူဟန်များကို အိန္ဒိယ နှင့် ထိုင်းတို့တွင်လည်း
      တွေ့နိုင်သည်။ အိန္ဒိယတွင် လယ်ထဲဝင်သည့် ကျိုင်းကောင်များ ကိုမောင်းထုတ်ရန်
      သံပုံတီးခတ်ခြင်း ပြုလုပ်ကျသလို ထိုင်းနိုင်ငံတွင်လည်း မဖိတ်ခေါ်သော
      မကျိုဆိုသော လူများရောက်ရှိသည့်အခါ သံပုံးခေါက်ပြီး
      မောင်းထုတ်ခြင်းများပြုလုပ်လေ့ရှိသည်။
    </p>
    <p class="myanmar">
      ထိုအခြင်းအကြောင်းအရာများကို သဘောပြု၍ ယခုအခါ အာဏာရှင်ဆန့်ကျင်ရေး အကြမ်းမဖက်
      သံပုံးခေါက်ခြင်း ၊ တီးခြင်း လှုပ်ရှားမှုကို ပြုလုပ်ကျသည်ဟု ယုံကြည်ပါသည်။
      မကျိုဆိုသော လူတစ်စု ၊ လက်မခံသော လူတစ်စုရဲ့ အစွန်းရောက်လုပ်ရပ်ကြောင့်
      ပြည်သူတို့ရဲ့ ရင်ထဲကအသံများနည်းတူ သံပုံးခေါင်သံများမှာ
      မြန်မာနိုင်ငံကြီးတွင် ည ၈ နာရီတိုင်း တဝုန်းဝုန်း တဒိုင်းဒိုင်း
      ကြာရပေဦးမည် ။
    </p>
  </div>
</template>

<script>
export default {
  name: "MyanmarInfo",
};
</script>

<style>
.myanmar {
    font-family: "Padauk";
}
</style>